
import { TemplateType } from '../../../common/EmailDetails';
import customerServiceSurveyImage from "../../../images/customer-service-survey.png";

export const getEmailContentHTML = (
  templateType: TemplateType,
  data: { [key: string]: string },
  dataList? : { [key: string]: string }[]
) => {
  switch (templateType) {
    case TemplateType.BLANK:
      return BLANK_HTML;
    case TemplateType.ARC_PRE_ARRIVAL:
      return ARC_PRE_ARRIVAL_HTML + Baggage_HTML;
    case TemplateType.US_FLYING:
      return US_FLYING_HTML + Baggage_HTML;
    case TemplateType.US_LOCAL:
      return US_LOCAL_HTML + Baggage_HTML;
    case TemplateType.FOREIGN:
      return FOREIGN_HTML + Baggage_HTML;
    case TemplateType.MARAD_PRE_ARRIVAL:
      return MARAD_PRE_ARRIVAL_HTML;
    case TemplateType.MARAD_LOCAL:
      return MARAD_LOCAL_HTML + Baggage_HTML;
    case TemplateType.MARAD_FOS:
      return MARAD_FOS_HTML + Baggage_HTML;
    case TemplateType.MARLIN_PRE_ARRIVAL:
      return MARLIN_PRE_ARRIVAL_HTML + Baggage_HTML;
    case TemplateType.JAX_FLYING:
      return JAX_FLYING_HTML + Baggage_HTML;
    case TemplateType.JAX_LOCAL:
      return JAX_LOCAL_HTML + Baggage_HTML;
    case TemplateType.SAN_JUAN_FLYING:
      return SAN_JUAN_FLYING_HTML + Baggage_HTML;
    case TemplateType.SAN_JUAN_LOCAL:
      return SAN_JUAN_LOCAL_HTML + Baggage_HTML;
    case TemplateType.ORCA_PRE_ARRIVAL:
      return ORCA_PRE_ARRIVAL_HTML + Baggage_HTML;
    case TemplateType.SEA_FLYING:
      return SEA_FLYING_HTML + Baggage_HTML;
    case TemplateType.SEA_LOCAL:
      return SEA_LOCAL_HTML + Baggage_HTML;
    case TemplateType.ANC_FLYING:
      return ANC_FLYING_HTML + Baggage_HTML;
    case TemplateType.ANC_LOCAL:
      return ANC_LOCAL_HTML + Baggage_HTML;
    case TemplateType.PRE_ARRIVAL:
      return PRE_ARRIVAL_HTML;
    case TemplateType.JOINING_INSTRUCTIONS:
      return JOINING_INSTRUCTIONS_HTML + Baggage_HTML;  
    case TemplateType.TRAINING_STAR_CENTER:
      return TRAINING_STAR_CENTER_HTML + Baggage_HTML;
    case TemplateType.TRAINING_ATO_AND_CBRD:
      return TRAINING_ATO_AND_CBRD_HTML + Baggage_HTML;  
    case TemplateType.TRAINING_LE_COMSEC_EAST:
      return TRAINING_LE_COMSEC_EAST_HTML + Baggage_HTML;  
    case TemplateType.TRAINING_LE_COMSEC_WEST:
      return TRAINING_LE_COMSEC_WEST_HTML + Baggage_HTML;  
    case TemplateType.TRAINING_LNG_FIRE_FIGHTING:
      return TRAINING_LNG_FIRE_FIGHTING_HTML + Baggage_HTML;
    case TemplateType.TRAINING_MECK:
      return TRAINING_MECK_HTML + Baggage_HTML;
    case TemplateType.TRAVEL_AGENT:
      return TRAVEL_AGENT_HTML(data);
    case TemplateType.TRAVEL_AGENT_MULTI:
      return TRAVEL_AGENT_MULTI_HTML(dataList);
    case TemplateType.EVALUATION_REMINDER:
      return EVALUATION_REMINDER_HTML(data);
    default:
      return ``;
  }
};

const BLANK_HTML = `<p><br></p>`;

const Baggage_HTML = `<p><strong style="color: rgb(23, 43, 77);">Baggage for up to 2 bags (under 50 pounds each) is reimbursable.</strong></p>
<p><strong><p /><span style="color: rgb(222, 53, 11);">NOTE: It is the crew member’s responsibility to ensure that they report aboard with sufficient amount of any prescription medications to last the ENTIRE period they will be assigned to the vessel.&nbsp;All medication will be required to be reported to the Master during the sign-on process.&nbsp;Due to safety reasons, failure to disclose medications is grounds for immediate dismissal from the vessel and crew members will be responsible for the cost of travel home.</span></strong></p><p />`;

const TRAINING_STAR_CENTER_HTML = `<p>Good Day,</p>
<p>&nbsp;</p>
<p>Please see attached flight and instructions below. Please let me know if you have any questions!</p>
<p>&nbsp;</p>
<p><strong>Training Date: mm/dd/yyyy </strong></p>
<p><strong>Training Location:&nbsp;</strong></p>
<p>&nbsp;</p>
<ul>
  <li>Meals and lodging are included at the Star Center.</li>
  <li>All receipts must be itemized.</li>
  <li>No alcohol on receipts.</li>
  <li>All mileage will need google snapshot.</li>
  <li><strong>Please use expense report attached!</strong></li>
  <li style="color: red;">After hour emergency number 503-978-6560</li>
</ul>
<p>&nbsp;</p>
<p><strong>Please send in your training certificate and expense report to the emails below for processing. Expense reports/wages will not be processed without certificate submittal.</strong></p>
<ul>
  <li><strong>Certificates &gt; <a href="mailto:training@toteservices.com">training@toteservices.com</a></strong></li>
  <li><strong>Expense Report &gt; <a href="mailto:expense@toteservices.com">expense@toteservices.com</a></strong></li>
  <li><strong>Wages - will be processed once the certificate is received.</strong></li>
</ul>
<p><br></p>
`;

const TRAINING_LNG_FIRE_FIGHTING_HTML = `<p>Good Day,</p>
<p>&nbsp;</p>
<p>Please see attached flight and instructions below. Please let me know if you have any questions!</p>
<p>&nbsp;</p>
<p><strong><mark>Training Date: mm/dd/yyyy </mark></strong></p>
<p><strong><mark>Start Time: 0900 - please arrive 15 minutes early.</mark></strong></p>
<p>Dress Code: Pants, closed toe shoes, t-shirt. (NO: Flip flops, sandals or shorts)</p>
<p>&nbsp;</p>
<p><strong><u>Location:</u></strong></p>
<p><strong>Fire Academy of the South</strong></p>
<p><strong>2700 Firefighter Memorial Drive</strong></p>
<p><strong>Jacksonville, FL 32246</strong></p>
<p>&nbsp;</p>
<p><strong><u>Lodging:</u></strong>&nbsp;</p>
<p>&nbsp;</p>
<ul>
  <li>Meals - submit receipts.</li>
  <li>All receipts must be itemized.</li>
  <li>No alcohol on receipts.</li>
  <li>All mileage will need google snapshot.</li>
  <li><strong>Please use expense report attached!</strong></li>
  <li style="color: red;">After hour emergency number 503-978-6560</li>
</ul>
<p>&nbsp;</p>
<p><strong>Please send in your training certificate and expense report to the emails below for processing. Expense reports/wages will not be processed without certificate submittal.</strong></p>
<ul>
  <li><strong>Certificates &gt; <a href="mailto:training@toteservices.com">training@toteservices.com</a></strong></li>
  <li><strong>Expense Report &gt; <a href="mailto:expense@toteservices.com">expense@toteservices.com</a></strong></li>
</ul>
<p><br></p>
`;

const TRAINING_MECK_HTML = `<p>Good Day,</p>
<p>&nbsp;</p>
<p>Please see your attached flight and report instructions below for MECK Training.</p>
<p>&nbsp;</p>
<p><strong><mark>Class Start Date: mm/dd/yyyy </mark></strong></p>
<p><strong><mark>Start Time: 0830 - please arrive 15 minutes early.</mark></strong></p>
<p>Attire: Business casual - slacks and collared shirt. No shorts or flip flops.</p>
<p>&nbsp;</p>
<p><strong><u>HOTEL:</u></strong>&nbsp;</p>
<p>&nbsp;</p>
<p><strong><u>Base Location:</u></strong></p>
<p><strong>530 Independence Pkwy., Suite 100, Chesapeake, VA 23320.</strong></p>
<p>&nbsp;</p>
<p><strong><u>BASE FYI:</u></strong></p>
<ul>
  <li>Our building is secured from 1700 to 0800.</li>
  <li>Due to security restrictions, students are not authorized to enter the building before 0800.</li>
</ul>
<p>&nbsp;</p>
<ul>
  <li>Please use government per diem rate.</li>
  <li>All receipts must be itemized.</li>
  <li>No alcohol on receipts.</li>
  <li>All mileage will need google snapshot.</li>
  <li><strong>Please use expense report attached!</strong></li>
  <li style="color: red;">After hour emergency number 503-978-6560</li>
</ul>
<p>&nbsp;</p>
<p><strong>Please send in your training certificate and expense report to the emails below for processing. Expense reports/wages will not be processed without certificate submittal.</strong></p>
<ul>
  <li><strong>Certificates &gt; <a href="mailto:training@toteservices.com">training@toteservices.com</a></strong></li>
  <li><strong>Expense Report &gt; <a href="mailto:expense@toteservices.com">expense@toteservices.com</a></strong></li>
</ul>
<p><br></p>
`;

const TRAINING_ATO_AND_CBRD_HTML = `<p>Good Day,</p>
<p>&nbsp;</p>
<p>Please see attached flight and instructions below. Please let me know if you have any questions! </p>
<p>&nbsp;</p>
<p><strong><mark>Class Start Date: mm/dd/yyyy </mark></strong></p>
<p><strong><mark>Start Time: 0700 - please arrive 15 minutes early.</mark></strong></p>
<p>Attire: Students should be in compliance with the standard CMPI uniform as they would be on the ship. They must also comply with MSC’s beard policy.</p>
<p>&nbsp;</p>
<p><strong><u>HOTEL:</u></strong>&nbsp;</p>
<p>&nbsp;</p>
<p><strong><u>Base Location:</u></strong></p>
<p>650 Monroe Ave</p>
<p>For Eustis</p>
<p>&nbsp;</p>
<p><strong><u>BASE FYI:</u></strong></p>
<ul>
  <li>Traffic getting on base is usually not that bad, but there is construction on the small bridge on Fort Eustis Blvd off of I-64 which can cause minor delays because two lanes go down to one.</li>
  <li>Students should leave enough time to combat that, so I recommend they plan to arrive around 0630-0645</li>
  <li>Students should go STRAIGHT through the stop sign into the parking lot if arriving between 0630 and 0730.</li>
</ul>
<p>&nbsp;</p>
<ul>
  <li>Please use government per diem rate.</li>
  <li>All receipts must be itemized.</li>
  <li>No alcohol on receipts.</li>
  <li>All mileage will need google snapshot.</li>
  <li><strong>Please use expense report attached!</strong></li>
  <li style="color: red;">After hour emergency number 503-978-6560</li>
</ul>
<p>&nbsp;</p>
<p><strong>Please send in your training certificate and expense report to the emails below for processing. Expense reports/wages will not be processed without certificate submittal.</strong></p>
<ul>
  <li><strong>Certificates &gt; <a href="mailto:training@toteservices.com">training@toteservices.com</a></strong></li>
  <li><strong>Expense Report &gt; <a href="mailto:expense@toteservices.com">expense@toteservices.com</a></strong></li>
</ul>
<p><br></p>
`;

const TRAINING_LE_COMSEC_WEST_HTML = `<p>Good Day,</p>
<p>&nbsp;</p>
<p>Please see your attached flight and report instructions below for LE COMSEC (EKMS) Training.</p>
<p>&nbsp;</p>
<p><mark><strong>Class Start Date: mm/dd/yyyy </strong></mark></p>
<p><mark><strong>Time: 0830 - please arrive 15 minutes early.</strong></mark></p>
<p>Attire: Business casual - slacks and collared shirt. No shorts or flip flops.</p>
<p>&nbsp;</p>
<p><u><mark><strong style="color: red;">Access to Base: Temporary Pass</strong></mark></u></p>
<ol>
  <li><u><mark><strong style="color: red;">On the first day before class,</strong></mark></u> please pickup your DBIDS card before class. Walk in allowed.</li>
  <li>Time: 06:30</li>
  <li>Location: 174 Rosecrans Street, San Diego, 92106 - right before main entrance.</li>
  <li><strong>Must have 2 valid government issues ID's to pick up DBIDS, NO EXCEPTIONS.</strong></li>
</ol>
<p>&nbsp;</p>
<p><u><strong>Base Location:</strong></u></p>
<p>140 Sylvester Rd, San Diego, CA on Point Loma Base - MSCPAC Building 570</p>
<p><strong>Due to security restrictions, students are not authorized to be in the building prior to 0800.</strong></p>
<p>Contact: 619-524-9895</p>
<p>&nbsp;</p>
<p>For directions, enter “Naval Base Point Loma” into a GPS. This will take you to Rosecrans St, which goes to the main gate of the base. After you enter the base, drive approximately one mile to the stop sign before the gas station, then take a right up the hill. When you get towards the top of the hill, you will come to a fork in the road. Take a right and MSCPAC Building 570 will be on your left. Then take a left into the parking lot. There will be a call button at the front door of building 570. Security will meet you there and get you checked in.</p>
<p>&nbsp;</p>
<p>POC for class:  Alfonso Deines, Instructor</p>
<p>POC Phone: (619) 524-9895</p>
<p>Email: <a href="mailto:alfonso.deines@tdisecurity.com">alfonso.deines@tdisecurity.com</a></p>
<p>&nbsp;</p>
<p>All visitors seeking entry to MSCPAC will be subject to Security Regulations, Force Protection Conditions, Health Protection Conditions, and other Safety/Emergency Measures as applicable.</p>
<ul>
  <li>Please utilize government per diem rate.</li>
  <li>All receipts must be itemized.</li>
  <li>No alcohol on receipts.</li>
  <li>All mileage will need google snapshot.</li>
  <li><strong>Please use expense report attached!</strong></li>
  <li style="color: red;">After hour emergency number 503-978-6560</li>
</ul>
<p>&nbsp;</p>
<p><strong>Please send in your training certificate and expense report to the emails below for processing. Expense reports/wages will not be processed without certificate submittal.</strong></p>
<ul>
  <li><strong>Certificates &gt; <a href="mailto:training@toteservices.com">training@toteservices.com</a></strong></li>
  <li><strong>Expense Report &gt; <a href="mailto:expense@toteservices.com">expense@toteservices.com</a></strong></li>
</ul>
<p><br></p>
`;

const TRAINING_LE_COMSEC_EAST_HTML = `<p>Good Day,</p>
<p>&nbsp;</p>
<p>Please see your attached flight and report instructions below for LE COMSEC (EKMS) Training.</p>
<p>&nbsp;</p>
<p><mark><strong>Class Start Date: mm/dd/yyyy </strong></mark></p>
<p><mark><strong>Time: 0830 - please arrive 15 minutes early.</strong></mark></p>
<p>Attire: Business casual - slacks and collared shirt. No shorts or flip flops.</p>
<p>The course will end on Thursday by 1300, barring any weather/power issues.</p>
<p>&nbsp;</p>
<p><u><mark><strong style="color: red;">Access to Base: Temporary Pass</strong></mark></u></p>
<ol>
  <li><u><mark><strong style="color: red;">On the first day before class,</strong></mark></u> please pickup your DBIDS card before class. Walk in allowed.</li>
  <li>Time: 0700</li>
  <li>Location: Little Creek Pass and ID Office</li>
  <li>1000 Helicopter Rd Virginia Beach, just outside Gate 3 of the JEB Little Creek Ft. Story Base, to obtain your pass.</li>
  <li><strong>Must have 2 valid government issues ID's to pick up DBIDS, NO EXCEPTIONS.</strong></li>
</ol>
<p>&nbsp;</p>
<p><u><strong>Base Location:</strong></u></p>
<p>2420 Stalwart Rd. Virginia Beach, VA 23459, Building 1562 (UNREP and ATG Training).</p>
<p>Parking is available at the side and front of the building.</p>
<p>JEB Base is on the corner of East Little Creek Road and Shore Drive. Once you enter the base, take a left at the light onto Amphibious Drive, go past Sumter Rd, then take a right on Stalwart Rd (street has no sign but will be the first street after Sumter Rd). The classroom will be on your left at the end of the street (Building 1562 UNREP and ATG Training). Parking is available on the side and front of the building.</p>
<p><u>POC for class:</u></p>
<ul>
  <li>Instructors of the class: David Ingersoll/ Zach Mollette</li>
  <li>Instructor Office Phone: (757) 462 5521</li>
</ul>
<p>&nbsp;</p>
<p>All personnel (regardless of vaccination status) will be required to conduct a daily self-screening prior to arrival at the Little Creek Facility.  Everyone is reminded that if they have any symptoms of COVID-19 or are otherwise not feeling well, they should avoid entering any MSC building.  They should immediately contact their supervisor and seek medical care.</p>
<ul>
  <li>Please utilize government per diem rate.</li>
  <li>All receipts must be itemized.</li>
  <li>No alcohol on receipts.</li>
  <li>All mileage will need google snapshot.</li>
  <li><strong>Please use expense report attached!</strong></li>
  <li style="color: red;">After hour emergency number 503-978-6560</li>
</ul>
<p>&nbsp;</p>
<p><strong>Please send in your training certificate and expense report to the emails below for processing. Expense reports/wages will not be processed without certificate submittal.</strong></p>
<ul>
  <li><strong>Certificates &gt; <a href="mailto:training@toteservices.com">training@toteservices.com</a></strong></li>
  <li><strong>Expense Report &gt; <a href="mailto:expense@toteservices.com">expense@toteservices.com</a></strong></li>
</ul>
<p><br></p>
`;

const PRE_ARRIVAL_HTML =  `<p>Good Day,</p>
<p>&nbsp;</p>
<p>In preparation for you joining our vessel, we are requesting additional steps to be completed prior to joining: - <i><strong style="background-color: rgb(255, 255, 0);">Please confirm receipt by responding to this email.</strong></i></p>
<p>&nbsp;</p>
<p><strong>Report Date:</strong> mm/dd/yyyy</p>
<p><strong>Report Location:&nbsp;</strong>&nbsp;</p>
<p><strong><span style="background-color: rgb(255, 255, 0);">Confirm Home Airport:</span> Please advise which airport you will be flying from&nbsp;</strong>&nbsp;</p>
<p>&nbsp;</p>
<p>Prior to joining the vessel, please complete these steps.</p>
    <ul>
      <li>
        <span style="background-color: rgb(255, 255, 0);"><b>Complete Onboarding packet sent via DocuSign.</b></span>
      </li>
      <li>
        <span style="background-color: rgb(255, 255, 0);"><b>Register in the Mariner Ship Management Tool (MSMT)</b></span>
      </li>
      <b>
        <ul>
          <li>Link to Register: <a href=https://toteservices-cmp.eaiapps.com/>https://toteservices-cmp.eaiapps.com/</a></li>
          <li>Email your Specialist by replying to this email if you are unable to register independently</li>
          <li>*Please confirm once registered*</li>
        </ul>
      </b>
    </ul>
    This tool will allow you to manage your mariner profile, upload documents, view travel, and communicate with TOTE Services Marine Personnel Specialists all in a secure location.
<p><br></p>
<p>Obtaining medication and supplies sufficient for the duration of the contract are the mariners responsibility prior to arrival.</p>
<p><br></p>
<p>Please let me know if you have any questions.&nbsp;</p>
<p><a href='https://forms.office.com/r/1GqaTUetnc'> <img src=${customerServiceSurveyImage} alt="Click Here to Rate our Customer Service"> </a></p>
<p><br></p>`;

const JOINING_INSTRUCTIONS_HTML = `<p>Good Day,</p>
<p>&nbsp;</p>
<p>Please see the below local instructions to join the <span style="background-color: rgb(255, 255, 0);">vessel in location</span></p>
<p>&nbsp;</p>
<p><strong><u>Joining Date:</u></strong> <span style="background-color: rgb(255, 255, 0);">mm/dd/yyyy</span></p>
<br>
<p><strong>Joining Time:</strong></p>
<p>Once you arrive, you will be transported to the vessel by <span style="background-color: rgb(255, 255, 0);">transportation company name.</span> I will provide <span style="background-color: rgb(255, 255, 0);">transportation company name</span> with your contact information. Please let me know if you have any further questions.</p>
<p><strong><u>Transportation Company Number:</u></strong></p>
<p><br></p>
<p><strong><u>Agents Info:</u></strong></p>
<p><br></p>
<p><strong>Please confirm you have received this email</strong></p>
<p><br></p>`;

const ARC_PRE_ARRIVAL_HTML = `<p>Good Day,</p>
<p>&nbsp;</p>
<p><strong>Report Date:&nbsp;</strong></p>
<p><strong>Report Location:&nbsp;</strong>&nbsp;</p>
<p><strong>Flying:</strong></p>
<p>&nbsp;</p>
<p><u><strong style="background-color: rgb(255, 255, 0);">Documents Needed:</strong></u></p>
<p>&nbsp;</p>
<p>Prior to joining the vessel, please complete these steps:&nbsp;</p>
<p><strong style="background-color: rgb(255, 255, 0);">**You will NOT be able to join the vessel without returning completed paperwork**</strong></p>
<p><br></p>
<ol>
    <li><strong style="background-color: rgb(255, 255, 0);">Sign the Safety &amp; Health Acknowledgement within 48 hours of receipt;</strong>
        <ul>
            <li><span style="list-style-type: lower-alpha;">It will come from DocuSign</span></li>
        </ul>
    </li>
</ol>
<ul>
    <li>State and local port state guidelines and restrictions vary. Crew member may be restricted to the vessel during port calls;&nbsp;</li>
    <li>Bring sufficient medication and supplies for the duration of your contract and longer.&nbsp;</li>
</ul>
<br>
<p>The health and wellbeing of our crew members is a priority for TOTE Services.&nbsp;</p>
<p><br></p>`;

const US_FLYING_HTML = `<p>Good Day,</p>
<p>&nbsp;</p>
<p>Please see your attached flight and joining instructions below.</p>
<p>&nbsp;</p>
<p><span><strong>Joining Date:</strong></span></p>
<p><span><strong>Flying:</strong></span></p>
<p>&nbsp;</p>
<ul>
   <li>Once you arrive in <strong style="background-color: rgb(255, 255, 0);">LOCATION</strong> you will be picked up by <strong style="background-color: rgb(255, 255, 0);">Transportation</strong> the airport and transported to the vessel.</li>
   <li>I will be giving them your contact and arrival information.</li>
   <li>Please contact transportation once you arrive. <strong style="background-color: rgb(255, 255, 0);"># PHONE</strong></li>
   <li><span style="color: rgb(222, 53, 11);">After hour emergency number 503-978-6560</span></li>
</ul>
<p>&nbsp;</p>
<p><strong><u>Please confirm this has been received.</u></strong></p>
<br>
<p><strong><u>Transportation:</u></strong></p>
<p><br></p>
<p><br></p>
<p><strong><u>Agent:</u></strong></p>
<p><br></p>
<p><br></p>`;

const US_LOCAL_HTML = `<p>Good Day,</p>
<p>&nbsp;</p>
<p>Please see joining instructions below.</p>
<br>
<p><strong>Report Date:</strong></p>
<p><strong>Report Time:</strong></p>
<br>
<ul>
  <li><strong>Vessel Address:</strong></li>
  <li>Please call <strong style="background-color: rgb(255, 255, 0);">Transportation</strong> 24 hours before joining the ship to set up the escort to the vessel.</li>
  <li>Please let me know if you have any further questions.</li>
</ul>
<br>
<p><strong><u>Transportation:</u></strong></p>
<p><br></p>
<p><br></p>
<p><strong><u>Agent:</u></strong></p>
<p><br></p>
<p><br></p>`;

const FOREIGN_HTML = `<p>Good Day,</p>
<p>&nbsp;</p>
<p>Please see your attached flight and joining instructions below.</p>
<p>&nbsp;</p>
<p><span><strong>Report Date:</strong></span></p>
<p><span><strong>Flying:</strong></span></p>
<br>
<p><strong style="background-color: rgb(255, 255, 0);"><u>*Please print and Carry:</u></strong></p>
<br>
<ul>
   <li>Once you arrive in <strong style="background-color: rgb(255, 255, 0);">LOCATION</strong> you will be picked up by Agent at the airport and transported to the <strong style="background-color: rgb(255, 255, 0);">HOTEL/OR/VESSEL</strong>.</li>
   <li>Agent will provide hotel & transport to the vessel the next day.</li>
   <li>I will be giving them your contact and arrival information.</li>
   <li><span style="color: rgb(222, 53, 11);">After hour emergency number 503-978-6560</span></li>
</ul>
<p>&nbsp;</p>
<p><strong><u>Please confirm this has been received.</u></strong></p>
<br>
<p><strong><u>Agent Details:</u></strong></p>
<p><br></p>
<p><br></p>`;

const MARAD_PRE_ARRIVAL_HTML = `<p>Good Day,</p>
<p>&nbsp;</p>
<p>In preparation for you joining our vessel, we are requesting additional steps to be completed prior to joining: - <i><strong style="background-color: rgb(255, 255, 0);">Please confirm receipt by responding to this email.</strong></i></p>
<p>&nbsp;</p>
<p><strong>Report Date:</strong> mm/dd/yyyy</p>
<p><strong>Report Location:&nbsp;</strong>&nbsp;</p>
<p><strong><span style="background-color: rgb(255, 255, 0);">Confirm Home Airport:</span> Please advise which airport you will be flying from&nbsp;</strong>&nbsp;</p>
<p>&nbsp;</p>
<p>Prior to joining the vessel, please complete these steps:&nbsp;</p>
<ul>
    <li><strong>You will not be able to join the vessel without returning completed paperwork.</strong></li>
    <li>State and local port state guidelines and restrictions vary. Crew member may be restricted to the vessel during port calls;</li>
    <ul>
        <li>Bring sufficient medication and supplies for the duration of your contract.</li>
    </ul>
</ul>
<p><br></p>
<p>The health and wellbeing of our crew members is a priority for TOTE Services.&nbsp;</p>
<p><br></p>`;

const MARAD_LOCAL_HTML = `<p>Good Day,</p>
<p>&nbsp;</p>
<p>Please see the below local instructions to join the <span style="background-color: rgb(255, 255, 0);"><strong>ship</strong> in city.</span></p>
<p>&nbsp;</p>
<p><strong><u>Joining Date:</u></strong> <span style="background-color: rgb(255, 255, 0);">mm/dd/yyyy</span></p>
<br>
<p><i><span style="color: rgb(0, 32, 96);">Please confirm receipt by responding to this email.</span></i></p>
<br>
<ul>
  <li>Arrive at 1000am to the ship.</li>
  <li><strong>Address:</strong></li>
  <li>Please call <span style="background-color: rgb(255, 255, 0);">transportation company name</span> 24 hours prior to joining the ship to set up the escort to the vessel.</li>
  <li>You will also need to contact <span style="background-color: rgb(255, 255, 0);">transportation company name</span> 1 hour before they arrive.</li>
  <li><span style="background-color: rgb(255, 255, 0);">transportation company name</span> will meet member outside the gate by the bus loop.</li>
  <li>Please let me know if you have any further questions.</li>
</ul>
<p><br></p>
<p><strong><u>Agents Info:</u></strong></p>
<p><br></p>
<p><strong><u>Please confirm you have received this email</u></strong></p>
<p><br></p>`;

const MARAD_FOS_HTML = `<p>Good Day,</p>
<p>&nbsp;</p>
<p>Please see the below travel and joining instructions to join the <span style="background-color: rgb(255, 255, 0);"><strong>ship</strong> in city.</span></p>
<p>&nbsp;</p>
<p><strong>Joining Date:</strong> <span style="background-color: rgb(255, 255, 0);">mm/dd/yyyy</span></p>
<p><strong>Joining Time:</strong></p>
<br>
<p><i><span style="color: rgb(0, 32, 96);">Please confirm receipt by responding to this email.</span></i></p>
<p>&nbsp;</p>
<ul>
   <li>Once you arrive in <span style="background-color: rgb(255, 255, 0);">city</span> you will be transported to the vessel by <span style="background-color: rgb(255, 255, 0);">transportation company name</span>.</li>
   <li>I will provide <span style="background-color: rgb(255, 255, 0);">transportation company name</span> with your contact information.</li>
   <li>Please let me know if you have any further questions.</li>
</ul>
<br>
<p><strong><u>Transportation Company Number:</u></strong></p>
<p><br></p>
<p><strong><u>Agents Info:</u></strong></p>
<p><br></p>
<p><strong><u>Please confirm this has been received.</u></strong></p>
<p><br></p>`;

const MARLIN_PRE_ARRIVAL_HTML = `<p>Good Day,</p>
<p>&nbsp;</p>
<p><strong>Report Date:&nbsp;</strong></p>
<p><strong>Report Location:&nbsp;</strong>&nbsp;</p>
<p>Flying:&nbsp;</p>
<p>&nbsp;</p>
<p>Prior to joining the vessel, please complete these steps:&nbsp;</p>
<p><strong style="background-color: rgb(255, 255, 0);">**You will <u>NOT</u> be able to join the vessel without returning completed paperwork**</strong></p>
<p><br></p>
<p><strong><u>Pre-Joining Requirements:</u></strong></p>
<ol>
    <li><strong style="background-color: rgb(255, 255, 0);">Sign the Safety &amp; Health Acknowledgement within 48 hours of receipt;</strong>
        <ul>
            <li><span style="list-style-type: lower-alpha;">It will come from DocuSign</span></li>
        </ul>
    </li>
</ol>
<ul>
    <li>State and local port state guidelines and restrictions vary. Crew member may be restricted to the vessel during port calls;&nbsp;</li>
    <li>Bring sufficient medication and supplies for the duration of your contract.&nbsp;</li>
</ul>
<p><br></p>
<p>The health and wellbeing of our crew members is a priority for TOTE Services.&nbsp;</p>
<p><br></p>`;

const JAX_FLYING_HTML = `<p>Good Day,</p>
<p>&nbsp;</p>
<p>Please see your attached flight and joining instructions below.</p>
<p>&nbsp;</p>
<p><strong><span style="background-color: rgb(255, 255, 0);"><u>********</u></span><u>&nbsp;&ndash; Joining Instructions:</u></strong>&nbsp;</p>
<p>&nbsp;</p>
<p><strong>Report Date:&nbsp;</strong></p>
<p><strong>Report Time:&nbsp;</strong></p>
<p>&nbsp;</p>
<ol>
   <li>Once you land, please take a taxi/uber to the vessel.&nbsp;</li>
   <li><strong>TOTE Building Address</strong>: 5250 William Mills Street, Jacksonville, FL 32226</li>
   <li>Call FCT Security Rover for transport to vessel port from TOTE Building/parking area.&nbsp;</li>
</ol>
<ul>
   <li>FCT Rover #904-832-1746</li>
   <li>Please keep all receipts for reimbursement.&nbsp;</li>
   <li><strong><u>Please confirm you have received this email</u></strong></li>
   <li><span style="color: rgb(222, 53, 11);">After hour emergency number 503-978-6560</span></li>
</ul>
<p>&nbsp;</p>
<p><strong>*Please be advised Smoking is prohibited on all areas of the vessel*&nbsp;</strong></p>
<p><br></p>`;

const JAX_LOCAL_HTML = `<p>Good Day,</p>
<p>&nbsp;</p>
<p>Please see joining instructions below.</p>
<p>&nbsp;</p>
<p><span style="background-color: rgb(255, 255, 0);"><u>********</u></span><u>&nbsp;</u><strong><u>&ndash; Local Joining Instructions:&nbsp;</u></strong></p>
<br>
<p><strong>Report Date:</strong></p>
<p><strong>Report Time:</strong></p>
<br>
<ol>
    <li>TOTE Building Address: 5250 William Mills Street, Jacksonville, FL 32216</li>
    <li>Call FCT Security Rover for transport to vessel port from TOTE Building/parking area.&nbsp;</li>
</ol>
<ul>
    <li>FCT Rover #904-832-1746</li>
    <li>POV are <strong><u>NOT Allowed</u></strong> to be driven to the dock.</li>
    <li><strong><u>Please confirm you have received this email</u></strong></li>
    <li><span style="color: rgb(222, 53, 11);">After hour emergency number 503-978-6560</span></li>
</ul>
<br>
<p><strong>*Please be advised Smoking is prohibited on all areas of the vessel*</strong></p>
<p><br></p>`;

const SAN_JUAN_FLYING_HTML = `<p>Good Day,</p>
<p>&nbsp;</p>
<p>Please see attached flight and joining instructions below.</p>
<p>&nbsp;</p>
<p><span style="text-decoration: underline;"><span class="s1"><u><strong><span style="background-color: #ffff00;">********</span> &ndash; Local Joining Instructions: </strong></u></span></span></p>
<br>
<p><strong>Report Date: </strong></p>
<p><strong>Report Time: </strong></p>
<br>
<ul>
<li>Once you land please take an UBER/Taxi to the address below.</li>
<li><span style="color: rgb(222, 53, 11);">After hour emergency number 503-978-6560</span></li>
</ul>
<br>
<p><strong>*Please be advised Smoking is prohibited on all areas of the vessel*</strong></p>
<br>
<p><span style="text-decoration: underline;"><span class="s1"><strong><u>Vessel Address:</u> </strong></span></span></p>
<p>Puerto Nuevo Terminal Avenida C,</p>
<p>Pier H Zona Portuaria,</p>
<p>San Juan, PR 00920</p>
<p><br></p>`;

const SAN_JUAN_LOCAL_HTML = `<p>Good Day,</p>
<p>&nbsp;</p>
<p>Please see joining instructions below.</p>
<p>&nbsp;</p>
<p><span style="text-decoration: underline;"><span class="s1"><strong><u><span style="background-color: #ffff00;">********</span> &ndash; Local Joining Instructions: </strong></u></span></span></p>
<br>
<p><strong>Report Date: </strong></p>
<p><strong>Report Time: </strong></p>
<br>
<ul>
  <li>Please take your POV or an UBER/Taxi to the address below.</li>
  <li><span style="color: rgb(222, 53, 11);">After hour emergency number 503-978-6560</span></li>
</ul>
<br>
<p><strong>*Please be advised Smoking is prohibited on all areas of the vessel*</strong></p>
<br>
<p><span style="text-decoration: underline;"><span class="s1"><strong><u>Vessel Address:</u> </strong></span></span></p>
<p>Puerto Nuevo Terminal Avenida C,</p>
<p>Pier H Zona Portuaria,</p>
<p>San Juan, PR 00920</p>
<p><br></p>`;

const ORCA_PRE_ARRIVAL_HTML = `<p>Good Day,</p>
<p>&nbsp;</p>
<p><strong>Report Date:&nbsp;</strong></p>
<p><strong>Report Location:&nbsp;</strong>&nbsp;</p>
<p>Flying:&nbsp;</p>
<p>&nbsp;</p>
<p>Prior to joining the vessel, please complete these steps:&nbsp;</p>
<p><strong style="background-color: rgb(255, 255, 0);">**You will <u>NOT</u> be able to join the vessel without returning completed paperwork**</strong></p>
<p><br></p>
<p><strong><u>Pre-Joining Requirements:</u></strong></p>
<ol>
    <li><strong style="background-color: rgb(255, 255, 0);">Sign the Safety &amp; Health Acknowledgement within 48 hours of receipt;</strong>
        <ul>
            <li><span style="list-style-type: lower-alpha;">It will come from DocuSign</span></li>
        </ul>
    </li>
</ol>
<ul>
    <li>State and local port state guidelines and restrictions vary. Crew member may be restricted to the vessel during port calls;&nbsp;</li>
    <li>Bring sufficient medication and supplies for the duration of your contract.&nbsp;</li>
</ul>
<p><br></p>
<p>The health and wellbeing of our crew members is a priority for TOTE Services.&nbsp;</p>
<p><br></p>`;

const SEA_FLYING_HTML = `<p>Good Day,</p>
<p>&nbsp;</p>
<p>Please see your attached flight and joining instructions below.</p>
<p>&nbsp;</p>
<p><strong><span style="background-color: rgb(255, 255, 0);"><u>********</u></span><u>&nbsp;&ndash; Joining Instructions:</u></strong>&nbsp;</p>
<p>&nbsp;</p>
<p><strong>Report Date:</strong></p>
<p><strong>Report Time:</strong></p>
<p>&nbsp;</p>
<ol>
   <li>Once you land, use Uber or Lyft to get to the vessel.&nbsp;</li>
</ol>
<ul>
   <li>Vessel Address: 500 East Alexander Ave, Tacoma, WA 98421</li>
   <li>Please keep all receipts for reimbursement.</li>
   <li><strong><u>Please confirm you have received this email</u></strong></li>
</ul>
<p>&nbsp;</p>
<p><strong>*Please be advised Smoking is prohibited on all areas of the vessel*&nbsp;</strong></p>
<p><br></p>`;

const SEA_LOCAL_HTML = `<p>Good Day,</p>
<p>&nbsp;</p>
<p>Please see joining instructions below.</p>
<p>&nbsp;</p>
<p><span style="background-color: rgb(255, 255, 0);"><u>********</u></span><u>&nbsp;</u><strong><u>&ndash; Local Joining Instructions:&nbsp;</u></strong></p>
<br>
<p><strong>Report Date:</strong></p>
<p><strong>Report Time:</strong></p>
<br>
<ol>
    <li>Vessel Address: 500 East Alexander Ave, Tacoma, WA 98421</li>
</ol>
<ul>
    <li><span style="color: rgb(222, 53, 11);">After hour emergency number 503-978-6560</span></li>
</ul>
<br>
<p><strong>*Please be advised Smoking is prohibited on all areas of the vessel*</strong></p>
<p><br></p>`;

const ANC_FLYING_HTML = `<p>Good Day,</p>
<p>&nbsp;</p>
<p>Please see your attached flight and joining instructions below.</p>
<p>&nbsp;</p>
<p><strong><span style="background-color: rgb(255, 255, 0);"><u>********</u></span><u>&nbsp;&ndash; Joining Instructions:</u></strong>&nbsp;</p>
<p>&nbsp;</p>
<p><strong>Report Date:</strong></p>
<p><strong>Report Time:</strong></p>
<p>&nbsp;</p>
<ol>
  <li>Take a taxi to the vessel location</li>
</ol>
<ul>
  <li><strong>Vessel Location  -  Anchorage Terminal</strong><br>2511 Tidewater Road<br>Anchorage, AK 99501</li>
  <li>Vessel Contact # <strong style="background-color: rgb(255, 255, 0);">phone</strong></li>
  <li>Please keep all receipts to be reimbursed by the Captain.&nbsp;</li>
  <li><span style="color: rgb(222, 53, 11);">After hour emergency number 503-978-6560</span></li>
</ul>
<br>
<p><strong>Taxi Services:</strong></p>
<ul>
  <li>Checker Cab - 24 hours - 907-644-4444</li>
  <li>Alaska Yellow Cab- 24 hours 907-222-2222</li>
</ul>
<p>&nbsp;</p>
<p><strong>*Please be advised Smoking is prohibited on all areas of the vessel*&nbsp;</strong></p>
<p><br></p>`;

const ANC_LOCAL_HTML = `<p>Good Day,</p>
<p>&nbsp;</p>
<p>Please see joining instructions below.</p>
<p>&nbsp;</p>
<p><strong>Report Date:</strong></p>
<p><strong>Report Time:</strong></p>
<p>&nbsp;</p>
<ol>
  <li>Take a taxi to the vessel location</li>
</ol>
<ul>
  <li><strong>Vessel Location  -  Anchorage Terminal</strong><br>2511 Tidewater Road<br>Anchorage, AK 99501</li>
  <li>Vessel Contact # <strong style="background-color: rgb(255, 255, 0);">phone</strong></li>
  <li>Please keep all receipts to be reimbursed by the Captain.&nbsp;</li>
  <li><span style="color: rgb(222, 53, 11);">After hour emergency number 503-978-6560</span></li>
</ul>
<br>
<p><strong>Taxi Services:</strong></p>
<ul>
  <li>Checker Cab - 24 hours - 907-644-4444</li>
  <li>Alaska Yellow Cab- 24 hours 907-222-2222</li>
</ul>
<p>&nbsp;</p>
<p><strong>*Please be advised Smoking is prohibited on all areas of the vessel*&nbsp;</strong></p>
<p><br></p>`;

const TRAVEL_AGENT_HTML = (data: { [key: string]: string }) => {
  return `<p>Good Day,</p>
  <p>&nbsp;</p>
  <p>Please provide options for:</p>
  ${TRAVEL_AGENT_TABLE_HTML(data)}
  <p><br></p>`;
};

const EVALUATION_REMINDER_HTML = (data: { [key: string]: string }) => {
  return `<p>Good Day,</p>
  <p>Please provide input on the Performance Evaluation for the following Mariner: </p>${
    data.rejectionNote ?
    `
    <p>Rejection Note: ${data.rejectionNote}</p>` : ''
  }
  <br>
  <p> <b>Mariner:</b> ${data.marinerName}</p>  
  <p> <b>Vessel Name:</b> ${data.vesselName}</p>  
  <p> <b>Mariner Rating:</b> ${data.rating}</p>  
  <br>
  <p>Click <a href=${data.evalLink}>here</a> to work on evaluation for ${
    data.marinerName
  }.</p>
  <div><br></div>`;
};

const TRAVEL_AGENT_MULTI_HTML = (dataList?: { [key: string]: string }[]) => {
  return `<p>Good Day,</p>
  <p>&nbsp;</p>
  <p>Please provide options for:</p>
  ${(dataList ?? [])
    .map((data) => TRAVEL_AGENT_TABLE_HTML(data))
    .join('<p><br></p>')}
  <p><br></p>`;
};

const TRAVEL_AGENT_TABLE_HTML = (data: { [key: string]: string }) => {
  return `<table style="width: 100%; border-collapse: collapse; border: solid rgb(0, 0, 0);">
      <tbody>
          <tr>
              <td style="width: 33.3333%; border: solid rgb(0, 0, 0);">Vessel Name: ${data.vesselName}</td>
              <td style="width: 33.3333%; border: solid rgb(0, 0, 0);"><br></td>
              <td style="width: 33.3333%; border: solid rgb(0, 0, 0);"><br></td>
          </tr>
          <tr>
              <td style="width: 33.3333%; border: solid rgb(0, 0, 0);">First Middle LAST (M/F):<br>${data.passenger} (${data.gender})</td>
              <td style="width: 33.3333%; border: solid rgb(0, 0, 0);">DOB: ${data.dob}</td>
              <td style="width: 33.3333%; border: solid rgb(0, 0, 0);">TWIC#: ${data.twicTsaNum}</td>
          </tr>
          <tr>
              <td style="width: 33.3333%; border: solid rgb(0, 0, 0);">Airport to airport:<br>${data.from} - ${data.to}</td>
              <td style="width: 33.3333%; border: solid rgb(0, 0, 0);">Date of travel: ${data.date}</td>
              <td style="width: 33.3333%; border: solid rgb(0, 0, 0);">Time Specification: ${data.time}</td>
          </tr>
          <tr>
              <td style="width: 33.3333%; border: solid rgb(0, 0, 0);">Hotel/rental info: ${data.hotelOrRental}</td>
              <td style="width: 33.3333%; border: solid rgb(0, 0, 0);">Check in: ${data.pickUpDate}</td>
              <td style="width: 33.3333%; border: solid rgb(0, 0, 0);">Check out: ${data.dropOffDate}</td>
          </tr>
          <tr>
              <td style="width: 33.3333%; border: solid rgb(0, 0, 0);">Mariner Cell Phone#: ${data.phone}</td>
              <td style="width: 33.3333%; border: solid rgb(0, 0, 0);"></td>
              <td style="width: 33.3333%; border: solid rgb(0, 0, 0);"></td>
          </tr>
      </tbody>
  </table>`;
}
